import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {locales} from '../../store/LocalizationStore';
import {TextButton, TextButtonTypes} from '../Buttons/index';
import styles from './style.css';

@inject('localizationStore')
@observer
class LanguageDropDown extends Component {
    languages = Object.keys(locales).map(l => ({
        value: l,
        label: locales[l][l]
    }))

    state = {
        language: this.languages[0].value,
        opened: false
    }

    onShowHideOptions = () => {
        this.setState({opened: !this.state.opened})
    }

    onChangeLocale = (lang) => {
        this.props.localizationStore.changeLocale(lang)
        this.setState({language: lang, opened: false})
    }

    render() {
        return (
            <div className={`${styles.menuItem} ${styles.langSelect}`} onClick={this.onShowHideOptions}>
                <TextButton textStyle={styles.selectedLang} type={TextButtonTypes.primary}>
                    {this.languages.find(l => l.value === this.state.language).label}
                </TextButton>
                <i className={`material-icons ${styles.expandIcon}`}>
                    {this.state.opened ? 'expand_less' : 'expand_more'}
                </i>
                <div className={this.state.opened ? styles.langOptionsVisible : styles.langOptionsHidden}>
                    {this.languages.map(l => {return(
                        <div className={this.state.language === l.value ? styles.selectedLangOption : styles.langOption}
                             key={l.value}
                             name={l.value}
                             onClick={() => this.onChangeLocale(l.value)}
                        >
                            {l.label}
                        </div>
                    )})}
                </div>

            </div>
        );
    }
}

export default LanguageDropDown;


// WEBPACK FOOTER //
// ./src/components/Header/LanguageDropdown.js